module.exports = __webpack_public_path__ + "img/icon-group6.3718dc28.png";